module.exports = __webpack_public_path__ + "Flag-818.d1afcd38b0a61a04bff87080b51a205c.svg";